import { render, staticRenderFns } from "./forums.vue?vue&type=template&id=433cc544&"
import script from "./forums.vue?vue&type=script&lang=js&"
export * from "./forums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports